import React from "react";
import "./styles.scss";

const jioPhotosAndroidTNC = () => {
  return (
    <>
      <div
        className="tnc-jiophotos-android-wrapper"
        spellCheck="false"
        tabIndex={0}
        contentEditable="false"
      >
        <div className="tnc-jiophotos-android-wrapper-info">
          <h3 id="tnc-jiophotos-android-wrapper-inner">
            Terms & Conditions for jiophotos&nbsp;
          </h3>
        </div>

        <ul className="tnc-jiophotos-android-wrapper-ul_style">
          <li role="presentation">
            <strong>1. SCOPE&nbsp;</strong>
          </li>
        </ul>
        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">1.1&nbsp;</li>
          <li>
            jiophotos XR is a mobile based Application, provided by Jio
            Platforms Limited and/or its affiliates Company we us and our
            located at 101, Saffron, Nr. Centre Point, Panchwati 5 Rasta,
            Ambawadi, Ahmedabad, Gujarat 380006 India.
          </li>
        </ul>
        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">1.2&nbsp;</li>
          <li>
            The Application is designed and made available by the Company and
            /or its affiliates to provide its users services such as access to
            photos and videos locally stored in the Device defined below;viewing
            of such photos and videos in virtual reality; and such other
            services as may be provided by the Company from time to time
            collectively known as Services on any compatible smart phones
            powered by Android Device. This Application has been devised for
            usage along with the augmented reality, virtual reality and/ or
            mixed reality products of the Company and/ or its affiliates.
          </li>
        </ul>
        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">1.3&nbsp;</li>
          <li>
            Your you your or user use of the Application is subject to these
            Terms and Conditions Terms
          </li>
        </ul>
        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">1.4&nbsp;</li>
          <li>
            Your use of the Application on the Device requires that you agree to
            these Terms and the privacy policy of the Application. By
            downloading the Application and by registering or signing up to the
            Application, or otherwise having access to, receiving, and/or using
            the Application, you acknowledge to have read, understood and you
            consent to be governed and bound by these Terms and the privacy
            policy of the Application. If you do not understand the Terms or the
            privacy policy of the Application, or do not accept any part of
            them, then you should not use the Application.
          </li>
        </ul>
        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">1.5&nbsp;</li>
          <li>
            The Terms are an electronic record in terms of the Information
            Technology Act, 2000 (as amended / re-enacted) (IT Act") and rules
            thereunder, and is published in accordance with the provisions of
            Rule 3 (1) (a) of Information Technology (Intermediary Guidelines
            and Digital Media Ethics code) Rules, 2021, which mandates for
            publishing of rules and regulations, privacy policy and terms of use
            for access or usage of Application. This electronic record is
            generated by a computer system and does not require any physical or
            digital signatures.
          </li>
        </ul>

        {/* 2nd */}
        <ul className="tnc-jiophotos-android-wrapper-ul_style">
          <li role="presentation">
            <strong>2. PRIVACY AND PROTECTION OF PERSONAL INFORMATION:</strong>
          </li>
        </ul>

        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">2.1.&nbsp;</li>
          <li>
            Please refer to the privacy policy of the Application available
            here.
          </li>
        </ul>
        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">2.2&nbsp;</li>
          <li>
            Please note that your use of the Application or Services on your
            Device and download thereof from Google play store may be subject to
            the respective privacy policies as may be published or made
            available by the Device and Google play store.
          </li>
        </ul>

        {/*  3rd */}
        <ul className="tnc-jiophotos-android-wrapper-ul_style">
          <li role="presentation">
            <strong>3. MODIFICATIONS</strong>
          </li>
        </ul>

        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">3.1&nbsp;</li>

          <li>
            <span style={{ fontFamily: "JioType-Bold" }}>
              Modifications of the Terms:&nbsp;
            </span>
            Modifications of the Terms: The Company reserves the right to change
            the Terms under which the Services are offered, including but not
            limited to the charges, if any, associated with the use of the
            Services. The Terms may be further modified based on changes in the
            business, legal and regulatory requirements and will be updated
            online. We will notify you whenever any change to the Terms and
            Conditions are made. You are encouraged to periodically visit this
            page to review these Terms and any changes to it.
          </li>
        </ul>

        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">3.2&nbsp;</li>
          <li>
            <span style={{ fontFamily: "JioType-Bold" }}>
              Modification of Services:&nbsp;
            </span>
            The Company reserves the right to add, modify or delete any content
            or features available in the Services at any time at its sole
            discretion.
          </li>
        </ul>

        <ul className="tnc-jiophotos-android-wrapper-ul_style">
          <li role="presentation">
            <strong>4. LINKS TO THIRD PARTY SITES AND APPLICATIONS: </strong>
          </li>

          <ul className="tnc-jiophotos-android-wrapper-content">
            <li role="presentation">4.1&nbsp;</li>
            <li>
              The Application may contain links to other web sites/applications
              (Linked Sites. The Linked Sites are not under the control of the
              Company and the Company is not responsible for the contents of any
              Linked Site, including without limitation any link contained in a
              Linked Site, or any changes or updates to a Linked Site or any
              information transmitted on a Linked Site. The inclusion of any
              link does not imply endorsement by the Company of the site or any
              association with its operators.
            </li>
          </ul>
        </ul>

        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">4.2&nbsp;</li>
          <li>
            Any dealings with third parties (including advertisers) included
            within or available via a link from the Application or participation
            in promotions, including the delivery of and the payment for goods
            and services, and any other terms, conditions, warranties or
            representations associated with such dealings or promotions, are
            solely between you and the advertiser or other third party. The
            Company shall not be responsible or liable for any part of any such
            dealings or promotions.
          </li>
        </ul>
        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">4.3&nbsp;</li>
          <li>
            You acknowledge and agree that the use of any Linked Sites is
            governed by such third partyâ€™s terms of use, license agreement,
            privacy policy, or other such agreement. THE COMPANY DISCLAIMS ANY
            AND ALL RESPONSIBILITY FOR ANY DISCLOSURE OF INFORMATION OR ANY
            OTHER PRACTICES OF ANY THIRD PARTY. THE COMPANY EXPRESSLY DISCLAIMS
            ANY WARRANTY WITH RESPECT TO YOUR PERSONAL OR OTHER INFORMATION THAT
            MAY BE COLLECTED, PROCESSED, SHARED OR RETAINED BY ANY THIRD PARTY
          </li>
        </ul>

        {/* 5th  */}
        <ul className="tnc-jiophotos-android-wrapper-ul_style">
          <li role="presentation">
            <strong>5. INTELLECTUAL PROPERTY RIGHTS:</strong>
          </li>
        </ul>
        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">5.1&nbsp;</li>
          <li>
            The Company and/ or its affiliates shall own title, interest and
            rights, including all related intellectual property rights, in/of
            the Application including but not limited to object code of the
            Application, features of services, which is/are protected by the
            applicable laws except the content owned by the user. You
            acknowledge that such ownership shall include all intellectual
            property rights arising from any suggestions, enhancement requests,
            recommendations or other information provided by the user, whether
            in the course of use of the Application, your Device or otherwise.
          </li>
        </ul>

        {/* 6th */}

        <ul className="tnc-jiophotos-android-wrapper-ul_style">
          <li role="presentation">
            <strong>6. USE LIMITATIONS:</strong>
          </li>
        </ul>
        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">6.1&nbsp;</li>
          <li>
            Services offered by the Application are intended solely for the
            purpose of availing Services provided by the Application. You may
            not distribute, transmit, display, perform, reproduce, publish,
            license, create derivative works from, transfer, or sell any
            information, software, products or Services offered by the
            Application.
          </li>
        </ul>
        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">6.2&nbsp;</li>
          <li>
            As a condition of your use of the Application, you warrant to the
            Company that you will not use the Application for any purpose that
            is unlawful or prohibited by these Terms. You may not use the
            Application in any manner which could damage, disable, overburden or
            impair the Services or interfere with any other party's use and
            enjoyment of the Application.
          </li>
        </ul>
        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">6.3&nbsp;</li>
          <li>
            You are not entitled to use any kind of measures, mechanisms or
            tools (software or hardware) that could interfere with the
            functioning of the Application or any of its Services.
          </li>
        </ul>
        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">6.4&nbsp;</li>
          <li>
            You may not use the Services and/or Application if (i) you have been
            convicted of any offence under applicable law; and/or (ii) if you
            are under the age of 18 years (subject to the below). If you are
            under the age of 18 years, you should review this Terms with your
            parent or legal guardian to make sure that you and your parent or
            legal guardian understand and agree to it and further if required
            your parent / legal guardian shall perform or undertake such
            activities to enter into a legally binding agreement with the
            Company.
          </li>
        </ul>
        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">6.5&nbsp;</li>
          <li>
            You agree that you will not upload on the Services, any Content that
            is contrary to the Terms and Conditions and the Companyâ€™s content
            guidelines, the Privacy Policy, or any other policy of Company, as
            updated from time to time, or that is contrary to applicable laws
            and regulations. If any such Content is uploaded on the Services and
            in your account in any manner and for any reason whatsoever, you
            shall ensure that such Content is deleted from the Services and your
            account immediately.
          </li>
        </ul>

        {/* 7th */}

        <ul className="tnc-jiophotos-android-wrapper-ul_style">
          <li role="presentation">
            <strong>7. USER NAMES AND PASSWORDS&nbsp;</strong>
          </li>
        </ul>
        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">7.1&nbsp;</li>
          <li>
            You may be required to register with the jiophotos-android
            application in order to access the Application using the means and
            methodology as provided by the Company from time to time.
          </li>
        </ul>
        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">7.2&nbsp;</li>
          <li>
            You are responsible for maintaining the confidentiality of any
            password including but not limited to one-time password you use to
            access the jiophotos-android application for purposes of this
            Application and you agree not to transfer such passwords or user
            names or lend or otherwise transfer your use or access to the
            jiophotos-android application or this Application to any third
            party. You agree to notify us of any unauthorized use of your
            passwords or user names or any other breach of security related to
            your account of which you become aware. You are fully responsible
            for all use of the Application and any Services that occur in
            connection with your user name, except to the extent that any
            unauthorized use is not caused by any breach of your obligations
            under these Terms.
          </li>
        </ul>

        {/* 8th */}
        <ul className="tnc-jiophotos-android-wrapper-ul_style">
          <li role="presentation">
            <strong>8. GENERAL:</strong>
          </li>
        </ul>
        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">8.1&nbsp;</li>
          <li>
            By using our Services you hereby agree to ensure that the explicit
            prohibitions mentioned in section 8.3 are at all times adhered to.
            The Company may use and/ or develop advanced technologies to detect
            any misuse of our Services. The Company reserves the right to use
            and/ or develop automated means and/ or systems to improve our
            ability to detect and/ or remove any prohibited conduct that may be
            in violation of the applicable law and/ or may harm the integrity of
            our Services
          </li>
        </ul>
        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">8.2&nbsp;</li>
          <li>
            Use Restriction: You must not access the Application if you are a
            person who is either barred or otherwise legally prohibited from
            receiving or using the Service or any Services under the laws of
            India.
          </li>
        </ul>
        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">8.3&nbsp;</li>
          <li>
            You shall not host, display, upload, modify, publish, transmit,
            update or share any information which:
            <ul className="tnc-jiophotos-android-wrapper-content">
              <li role="presentation">(a)&nbsp;</li>
              <li role="presentation">
                Belongs to another person and to which you do not have any right
                to;
              </li>
            </ul>
            <ul className="tnc-jiophotos-android-wrapper-content">
              <li role="presentation">(b)&nbsp;</li>
              <li role="presentation">
                Is grossly harmful, harassing, blasphemous, defamatory, obscene,
                pornographic, paedophilic, libellous, invasive of anotherâ€™s
                privacy, hateful, or racially, ethnically objectionable,
                disparaging, relating or encouraging money laundering or
                gambling or otherwise unlawful in any manner whatsoever; or
                unlawfully threatening or unlawfully harassing including but not
                limited to â€œindecent representation of womenâ€ within the
                meaning of the Indecent Representation of Women (Prohibition)
                Act 1986;
              </li>
            </ul>
            <ul className="tnc-jiophotos-android-wrapper-content">
              <li role="presentation">(c)&nbsp;</li>
              <li role="presentation">Is misleading in any way;</li>
            </ul>
            <ul className="tnc-jiophotos-android-wrapper-content">
              <li role="presentation">(d)&nbsp;</li>
              <li role="presentation">
                Is patently offensive to the online community, such as sexually
                explicit content, or content that promotes obscenity,
                paedophilia, racism, bigotry, hatred or physical harm of any
                kind against any group or individual;
              </li>
            </ul>
            <ul className="tnc-jiophotos-android-wrapper-content">
              <li role="presentation">(e)&nbsp;</li>
              <li role="presentation">
                Harassing or advocates harassment of another person;
              </li>
            </ul>
            <ul className="tnc-jiophotos-android-wrapper-content">
              <li role="presentation">(f)&nbsp;</li>
              <li role="presentation">
                Involves the transmission of junk mail, â€œchained letters, or
                unsolicited mass mailing or spamming;
              </li>
            </ul>
            <ul className="tnc-jiophotos-android-wrapper-content">
              <li role="presentation">(g)&nbsp;</li>
              <li role="presentation">
                Promotes illegal activities or conduct that is abusive,
                threatening, obscene, defamatory or libellous;
              </li>
            </ul>
            <ul className="tnc-jiophotos-android-wrapper-content">
              <li role="presentation">(h)&nbsp;</li>
              <li role="presentation">
                Infringes upon or violates any third partyâ€™s rights
                (including, but not limited to, intellectual property rights,
                rights of privacy or rights of publicity);
              </li>
            </ul>
            <ul className="tnc-jiophotos-android-wrapper-content">
              <li role="presentation">(i)&nbsp;</li>
              <li role="presentation">
                Promotes an illegal or unauthorized copy of another person
                copyrighted work;
              </li>
            </ul>
            <ul className="tnc-jiophotos-android-wrapper-content">
              <li role="presentation">(j)&nbsp;</li>
              <li role="presentation">
                Provides instructional information about illegal activities such
                as making and/ or buying illegal weapons, violating someone
                privacy, or providing or creating computer viruses;
              </li>
            </ul>
            <ul className="tnc-jiophotos-android-wrapper-content">
              <li role="presentation">(k)&nbsp;</li>
              <li role="presentation">
                Solicits gambling or engages in any gambling activity which we
                in our sole discretion believe is or could be construed to be as
                illegal;
              </li>
            </ul>
            <ul className="tnc-jiophotos-android-wrapper-content">
              <li role="presentation">(l)&nbsp;</li>
              <li role="presentation">Harms minors in any way;</li>
            </ul>
            <ul className="tnc-jiophotos-android-wrapper-content">
              <li role="presentation">(m)&nbsp;</li>
              <li role="presentation">
                Violates any law for the time being in force;
              </li>
            </ul>
            <ul className="tnc-jiophotos-android-wrapper-content">
              <li role="presentation">(n)&nbsp;</li>
              <li role="presentation">Impersonates another person;</li>
            </ul>
            <ul className="tnc-jiophotos-android-wrapper-content">
              <li role="presentation">(o)&nbsp;</li>
              <li role="presentation">
                Contains software viruses or any other computer code, files or
                programs designed to interupt, destroy or limit the
                functionality of any computer resource; or contains any trojan
                horses, worms, time bombs, cancelbots, easter eggs or other
                computer programming routines that may damage, detrimentally
                interfere with, diminish value of, surreptiously intercept or
                expropriate any system, data or personal information;.
              </li>
            </ul>
            <ul className="tnc-jiophotos-android-wrapper-content">
              <li role="presentation">(p)&nbsp;</li>
              <li role="presentation">
                Threatens the unity, integrity, defence, security or sovereignty
                of India, friendly relations with foreign states, or public
                order or causes incitement to the commission of any cognizable
                offense or prevents investigation of any offense or is insulting
                any other nation;
              </li>
            </ul>
          </li>
        </ul>
        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">8.4&nbsp;</li>
          <li>
            Services may be made available for free of cost or for a specified
            cost as may be decided by the Company from time to time.
          </li>
        </ul>
        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">8.5&nbsp;</li>
          <li>
            <span style={{ fontFamily: "JioType-Bold" }}>
              Third-Party Fees:&nbsp;
            </span>
            You may incur access or data fees from third parties (such as your
            internet provider or mobile carrier) in connection with your use of
            Services and of Application. You are solely responsible for all such
            fees.
          </li>
        </ul>
        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">8.6&nbsp;</li>
          <li>
            <span style={{ fontFamily: "JioType-Bold" }}>Updates:&nbsp;</span>
            Updates: You may need to install updates to the Application or
            related software that we introduce from time to time to use of the
            Application. Services originating from the Application may
            communicate with the servers from time to time to check for
            available updates to the Services and to the functionality of the
            Application, such as bug fixes, patches, enhanced functions, missing
            plug-ins and new versions (collectively, â€œUpdatesâ€). Your use of
            the Services you have installed requires that you have agreed to
            receive such automatically requested Updates.
          </li>
        </ul>
        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">8.7&nbsp;</li>
          <li>
            <span style={{ fontFamily: "JioType-Bold" }}>
              Accuracy of Information:&nbsp;
            </span>
            You agree that the information entered by you while profile
            creation/ updation or using any of Services is true, current,
            complete and accurate in all respects. The Company is not
            responsible for any losses arising out of discrepancy in your data.
            You are solely responsible for maintaining confidentiality and
            security of your user account and for all activities that occur on
            or through your user account. The Company is not responsible for any
            losses arising out of the unauthorized use of your user account.
          </li>
        </ul>

        {/* 9th */}
        <ul className="tnc-jiophotos-android-wrapper-ul_style">
          <li role="presentation">
            <strong>9. LIABILITY DISCLAIMER&nbsp;</strong>
          </li>
        </ul>
        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">9.1&nbsp;</li>
          <li>
            TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL
            THE COMPANY BE LIABLE TO YOU FOR ANY SPECIAL, INCIDENTAL, INDIRECT,
            PUNITIVE OR CONSEQUENTIAL DAMAGES WHATSOEVER (INCLUDING, WITHOUT
            LIMITATION, DAMAGES FOR LOSS OF USE, LOSS OF BUSINESS PROFITS,
            BUSINESS INTERRUPTION, LOSS OF INFORMATION, OR ANY OTHER PECUNIARY
            LOSS) ARISING OUT OF THE USE OF, OR INABILITY TO USE OR ACCESS, THE
            APPLICATION OR FOR ANY SECURITY BREACH OR ANY VIRUS, BUG,
            UNAUTHORIZED INTERVENTION, DEFECT, OR TECHNICAL MALFUNCTIONING OF
            THE APPLICATION, WHETHER OR NOT FORESEEABLE OR WHETHER OR NOT THE
            COMPANY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES, OR
            BASED ON ANY THEORY OF LIABILITY, INCLUDING BREACH OF CONTRACT OR
            WARRANTY, NEGLIGENCE OR OTHER TORTIOUS ACTION, OR ANY OTHER CLAIM
            ARISING OUT, OF OR IN CONNECTION WITH, YOUR USE OF, OR ACCESS TO,
            THE APPLICATION OR THE CONTENT. FURTHER, THE COMPANY SHALL NOT BE
            LIABLE TO YOU FOR ANY TEMPORARY DISABLEMENT, PERMANENT
            DISCONTINUANCE OR MODIFICATION OF THE APPLICATION BY THE COMPANY OR
            FOR ANY CONSEQUENCES RESULTING FROM SUCH ACTIONS.
          </li>
        </ul>
        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">9.2&nbsp;</li>
          <li>
            YOU SHALL BE SOLELY RESPONSIBLE FOR OBTAINING AND MAINTAINING ANY
            EQUIPMENT AND ANCILLARY SERVICES (INCLUDING THE PAYMENT OF ANY
            ADDITIONAL FEES THEREFORE) REQUIRED TO CONNECT TO, ACCESS OR
            OTHERWISE USE THE SERVICES, INCLUDING, WITHOUT LIMITATION, VIRTUAL
            REALITY DEVICES, VIDEO-ENABLED DEVICES, VIDEO COMMUNICATION
            SERVICES, MODEMS, HARDWARE, SERVERS, SOFTWARE, OPERATING SYSTEMS,
            NETWORKING, WEB SERVERS, INTERNET AND TELEPHONE SERVICE
            (COLLECTIVELY, â€œEQUIPMENTâ€). YOU WILL ALSO BE RESPONSIBLE FOR
            MAINTAINING THE SECURITY OF THE EQUIPMENT AND FOR ALL USES OF THE
            EQUIPMENT WITH OR WITHOUT YOUR KNOWLEDGE OR CONSENT
          </li>
        </ul>
        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">9.3&nbsp;</li>
          <li>
            YOU ARE SOLELY RESPONSIBLE FOR THE CONTENT AND OTHER MATERIALS YOU
            TRANSMIT THROUGH THE SERVICE OR SHARE WITH OTHER USERS OR
            RECIPIENTS. YOU WILL NOT TRANSMIT ANY CONTENT THAT YOU DID NOT
            CREATE OR THAT YOU DO NOT OWN ALL RIGHT, TITLE AND INTEREST IN AND
            TO, INCLUDING, WITHOUT LIMITATION, ALL COPYRIGHT AND RIGHTS OF
            PUBLICITY CONTAINED THEREIN
          </li>
        </ul>
        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">9.4&nbsp;</li>
          <li>
            THE COMPANY AND/OR ITS RESPECTIVE AFFILIATES MAKES NO
            REPRESENTATIONS ABOUT THE SUITABILITY, RELIABILITY, AVAILABILITY,
            TIMELINESS AND ACCURACY OF THE INFORMATION, SOFTWARE AND SERVICES
            AND RELATED CONTENT CONTAINED ON THE APPLICATION FOR ANY PURPOSE.
            ALL SUCH INFORMATION, SOFTWARE AND SERVICES AND RELATED CONTENT ARE
            PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND. THE COMPANY AND/OR
            ITS RESPECTIVE SUPPLIERS HEREBY DISCLAIMS ALL WARRANTIES AND
            CONDITIONS WITH REGARD TO THIS INFORMATION, SOFTWARE, AND SERVICES
            AND RELATED CONTENT, INCLUDING ALL IMPLIED WARRANTIES AND CONDITIONS
            OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE AND
            NON-INFRINGEMENT
          </li>
        </ul>
        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">9.5&nbsp;</li>
          <li>
            YOU SPECIFICALLY AGREE THAT THE COMPANY SHALL NOT BE RESPONSIBLE FOR
            UNAUTHORISED ACCESS TO OR ALTERATION OF YOUR TRANSMISSIONS OR DATA,
            ANY MATERIAL OR DATA SENT OR RECEIVED OR NOT SENT OR RECEIVED, OR
            ANY TRANSACTIONS ENTERED INTO THROUGH THE APPLICATION. YOU
            SPECIFICALLY AGREE THAT THE COMPANY IS NOT RESPONSIBLE OR LIABLE FOR
            ANY THREATENING, DEFAMATORY, OBSCENE, OFFENSIVE OR ILLEGAL SERVICES
            OR CONDUCT OF ANY OTHER PARTY OR ANY INFRINGEMENT OF ANOTHER'S
            RIGHTS, INCLUDING INTELLECTUAL PROPERTY RIGHTS. YOU SPECIFICALLY
            AGREE THAT THE COMPANY IS NOT RESPONSIBLE FOR ANY SERVICES SENT
            USING AND/OR INCLUDED IN THE APPLICATION BY ANY THIRD PARTY
          </li>
        </ul>
        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">9.6&nbsp;</li>
          <li>
            IN NO EVENT SHALL THE COMPANY AND/OR ITS AFFILIATES BE LIABLE FOR
            ANY DIRECT, INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL, CONSEQUENTIAL
            DAMAGES OR ANY DAMAGES WHATSOEVER INCLUDING, WITHOUT LIMITATION,
            DAMAGES FOR OR IN RELATION TO: (A) LOSS OF USE, DATA OR PROFITS
            ARISING OUT OF OR IN ANY WAY CONNECTED WITH THE USE OR PERFORMANCE
            OF APPLICATION; (B) ANY DELAY OR INABILITY TO USE THE APPLICATION OR
            SERVICES; (C) THE PROVISION OF OR FAILURE TO PROVIDE SERVICES, OR
            FOR ANY INFORMATION OR SERVICES OBTAINED THROUGH THE APPLICATION;
            (D) OR OTHERWISE ARISING OUT OF THE USE OF THE APPLICATION OR THE
            SERVICES OF THE COMPANY; WHETHER OR NOT ALL OF THE ABOVE LOSSES,
            CLAIMS OR DAMAGES ARE BASED ON CONTRACT, TORT, NEGLIGENCE, STRICT
            LIABILITY, EVEN IF THE COMPANY AND/OR ITS AFFILIATES AND/OR ITS
            ASSOCIATES HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH LOSSES,
            CLAIMS OR DAMAGES.
          </li>
        </ul>

        {/* 10th */}
        <ul className="tnc-jiophotos-android-wrapper-ul_style">
          <li role="presentation">
            <strong>
              10. TERMINATION (TEMPORARY AND PERMANENT DISABLEMENT):
            </strong>
          </li>
        </ul>
        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">10.1&nbsp;</li>
          <li>
            Unless otherwise provided in these Terms, the Services offered to
            you may be terminated by the Company without assigning any reasons
            at any time at the sole discretion of the Company. Upon termination
            / suspension, you shall not have the right to use or access the
            Application/Services.
          </li>
        </ul>
        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">10.2&nbsp;</li>
          <li>
            The Company reserves the right to suspend and/ or terminate your
            access to the Services in case of any non-adherence to these Terms
            and Conditions by you.
          </li>
        </ul>

        <ul className="tnc-jiophotos-android-wrapper-ul_style">
          <li role="presentation">
            <strong>11. GOVERNING LAW AND DISPUTE RESOLUTION:</strong>
          </li>
        </ul>
        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">11.1&nbsp;</li>
          <li>
            These Terms and Conditions are governed and construed in accordance
            with the laws of India. The courts in Mumbai shall have exclusive
            jurisdiction to hear disputes arising out of these terms.
          </li>
        </ul>

        <ul className="tnc-jiophotos-android-wrapper-ul_style">
          <li role="presentation">
            <strong>12. FORCE MAJEURE:</strong>
          </li>
        </ul>
        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">12.1&nbsp;</li>
          <li>
            The Company shall be under no liability whatsoever in the event of
            non-availability of any portion of the Application or subscribed
            content occasioned by act of God, war, disease, revolution, riot,
            civil commotion, strike, lockout, flood, fire, failure of any public
            utility, manmade disaster, infrastructure failure or any other cause
            whatsoever beyond the control of the Company.
          </li>
        </ul>

        <ul className="tnc-jiophotos-android-wrapper-ul_style">
          <li role="presentation">
            <strong>13. SEVERABILITY:</strong>
          </li>
        </ul>
        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">&nbsp;13.1&nbsp;</li>
          <li>
            If any of the provisions of these Terms are deemed invalid, void, or
            for any reason unenforceable, that part of these Terms will be
            deemed severable and will not affect the validity and enforceability
            of any remaining provisions of these Terms.
          </li>
        </ul>

        <ul className="tnc-jiophotos-android-wrapper-ul_style">
          <li role="presentation">
            <strong>14. CONTACT DETAILS:</strong>
          </li>
        </ul>
        <ul className="tnc-jiophotos-android-wrapper-content">
          <li role="presentation">&nbsp;14.1&nbsp;</li>
          <li>
            If you have any questions or concerns regarding these Terms or
            require any support in relation to the Application, you may write to
            us at: Mrs. Radha Nair, Reliance Corporate IT Park, TC-22, Thane
            Belapur Road, Ghansoli, Navi Mumbai 400701 Email id:
            grievance.officer@jio.com
          </li>
        </ul>
      </div>
    </>
  );
};

export default jioPhotosAndroidTNC;
